import React from "react";
import { Link } from "react-router-dom";
import meImage from "../assets/me.png";
import "./Home.css";

function Home() {
  const skills = {
    "보안/네트워크": ["Kali Linux", "Wireshark", "Cisco Packet Tracer", "UTM"],
    백엔드: ["Kotlin", "Java", "Spring Boot", "Spring WebFlux", "Python"],
    인프라: ["AWS", "Docker", "GitHub Actions", "Redis"],
    데이터베이스: ["PostgreSQL", "MySQL", "MariaDB"],
  };

  return (
    <main className="home">
      <section className="home-hero">
        <div className="container">
          <div className="hero-layout">
            <div className="hero-copy">
              <p className="hero-badge">Cyber Security / Backend</p>
              <h1>
                넓은 경험으로 빠르게 성장하는
                <br />
                <span>사이버보안 인재 심서훈</span>
              </h1>
              <p className="hero-text">
                2년간 8개의 팀 프로젝트를 수행하며 서비스 보안, 서버 개발,
                클라우드 운영 역량을 쌓았습니다. 협업 중심의 개발 문화를
                이해하고 실무형 보안 역량을 꾸준히 확장하고 있습니다.
              </p>
              <div className="hero-actions">
                <Link to="/projects" className="btn btn-primary">
                  프로젝트 보기
                </Link>
                <Link to="/contact" className="btn btn-ghost">
                  연락하기
                </Link>
                <a href="/심서훈_포트폴리오.pdf" download className="btn btn-ghost">
                  포트폴리오 다운로드
                </a>
              </div>
            </div>
            <div className="hero-photo-wrap">
              <img src={meImage} alt="my profile" className="hero-photo" />
            </div>
          </div>
        </div>
      </section>

      <section className="quick-stats">
        <div className="container stats-grid">
          <div className="stat">
            <h3>8+</h3>
            <p>팀 프로젝트</p>
          </div>
          <div className="stat">
            <h3>3</h3>
            <p>프로젝트 팀장 경험</p>
          </div>
          <div className="stat">
            <h3>2+</h3>
            <p>보안/개발 학습 연차</p>
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="container">
          <h2>기술 스택</h2>
          <div className="skills-grid">
            {Object.entries(skills).map(([category, items]) => (
              <article key={category} className="skill-card">
                <h3>{category}</h3>
                <div className="chip-list">
                  {items.map((item) => (
                    <span key={item} className="chip">
                      {item}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-section alt">
        <div className="container">
          <h2>핵심 활동</h2>
          <div className="activity-grid">
            <article className="activity-card">
              <h3>보안 스터디 창설 및 운영</h3>
              <p>2025.07 ~ 현재</p>
              <span>교외 보안 스터디 ‘보안공방’</span>
            </article>
            <article className="activity-card">
              <h3>정보보호영재교육 수료</h3>
              <p>2025.04 ~ 2025.10</p>
              <span>실무형 보안 교육 과정 이수</span>
            </article>
            <article className="activity-card">
              <h3>사이버테러 대응 시나리오 공모전</h3>
              <p>2025</p>
              <span>장려상 수상</span>
            </article>
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="container">
          <h2>대표 프로젝트 미리보기</h2>
          <div className="preview-grid">
            <article className="preview-card">
              <h3>Qvick</h3>
              <p>기숙사 통합 관리 플랫폼</p>
              <ul>
                <li>Spring WebFlux 기반 비동기 처리</li>
                <li>QR 출석 및 공지/알림 시스템</li>
              </ul>
            </article>
            <article className="preview-card">
              <h3>Finder</h3>
              <p>분실물 등록/검색 서비스</p>
              <ul>
                <li>Redis 기반 토큰 관리</li>
                <li>AWS S3 파일 분리 저장</li>
              </ul>
            </article>
          </div>
          <div className="center">
            <Link to="/projects" className="btn btn-primary">
              전체 프로젝트 상세 보기
            </Link>
          </div>
        </div>
      </section>

      <section className="home-cta">
        <div className="container">
          <div className="cta-box">
            <h2>사이버보안 직무 기회를 찾고 있습니다</h2>
            <p>
              보안 관점에서 서비스를 설계하고, 안정적으로 운영할 수 있는 인재로
              성장하고 있습니다.
            </p>
            <div className="hero-actions">
              <Link to="/about" className="btn btn-ghost">
                상세 이력 보기
              </Link>
              <Link to="/contact" className="btn btn-primary">
                연락하기
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
